/**
 * Parses an ISO timestamp, returning `undefined` for a missing/invalid value
 * so the timeline sort falls back to its `?? Infinity` guard rather than
 * poisoning the comparator with a `NaN` (which would scramble the order).
 */
export function toValidDate(value?: string): Date | undefined {
  if (!value) return undefined;
  const date = new Date(value);
  return Number.isNaN(date.getTime()) ? undefined : date;
}
